var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '~/providers/user';
import { Websocket } from './websocket';
const WebsocketContext = createContext({});
const WebsocketProvider = (props) => {
    const { id: userId, activeOrganization: organization } = useUser();
    const wsRef = useRef();
    const oldWSRef = useRef();
    const userInfoRef = useRef({ userId, organization });
    const [isWebsocketReady, setIsWebsocketReady] = useState(false);
    const navigate = useNavigate();
    const getWS = () => {
        const { userId, organization } = userInfoRef.current;
        if (!userId || !organization)
            return;
        return new Websocket(userId, organization, navigate, setIsWebsocketReady);
    };
    const replaceWS = () => {
        oldWSRef.current = wsRef.current;
        const { userId, organization } = userInfoRef.current;
        if (userId && organization) {
            wsRef.current = getWS();
        }
    };
    useEffect(() => {
        const replaceWebsocketInterval = setInterval(replaceWS, 9 * 60 * 1000);
        return () => {
            clearInterval(replaceWebsocketInterval);
        };
    }, []);
    useEffect(() => {
        userInfoRef.current = { userId, organization };
        if (!wsRef.current && userId && organization) {
            connect();
        }
    }, [userId, organization]);
    const connect = () => {
        const { userId, organization } = userInfoRef.current;
        if (userId && organization) {
            wsRef.current = getWS();
        }
    };
    const send = (eventType, payload, callback, eventId) => __awaiter(void 0, void 0, void 0, function* () {
        if (!wsRef.current)
            return;
        wsRef.current.send(eventType, payload, callback, eventId);
    });
    const ws = {
        isWebsocketReady,
        connect,
        send,
    };
    return React.createElement(WebsocketContext.Provider, Object.assign({ value: ws }, props));
};
const useWebsocket = () => {
    const ctx = useContext(WebsocketContext);
    if (!ctx) {
        throw new Error('Websocket Context is only usable under the WebsocketProvider in the tree.');
    }
    return ctx;
};
export { WebsocketProvider, useWebsocket };
